import { CohortModel } from '@/models/cohort/cohort';
import { cohortAPI } from '@/providers/apis/cohort/cohort';
import { groupsApi } from '@/providers/apis/groups/groups';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { copy } from '@/utils/cohort';
import { isEmpty } from '@/utils/utils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'cohort-list',
})

export default class CohortList extends Vue {

    // ---------------------------------------------------------------------
    // Properties

    @Prop()
    private cohort: any;

    @Prop({ default: null })
    private rowItemSelected: any;

    private rowSelected: any = null;

    private displayList: any = [];

    private selectedParent: any = {};

    private selectedRecentItem: any = {};

    private selectedCohort: any = [];

    private offset: number = 0;

    private limit: number = 50;

    private headerCheck = false;

    private indeterminate = false;

    private searchText: any = '';

    private isloadingLocal = false;

    @Watch('rowItemSelected', { deep: true })
    private async updatePreSelected(data: any) {
        this.selectedRecentItem = {};
        if (this.cohort.sequence === 1) {
            this.rowSelected = 0;
        } else {
            this.rowSelected = data;
        }
        this.selectedParent = this.cohort && this.cohort.child &&
            this.cohort.child[this.rowSelected] ? this.cohort.child[this.rowSelected] : {};
        this.displayList = this.selectedParent && this.selectedParent.cohortList ?
            this.cohort.child[this.rowSelected].cohortList : [];
        if (this.cohort.type === 'class') {
            if (this.displayList && this.displayList.length === 0 && this.rowSelected) {
                if (this.isloadingLocal) {
                    return;
                }
                this.isloadingLocal = true;
                const rowSelect = this.rowSelected;
                const classParam = {
                    groupId: rowSelect,
                };
                const classList = await taxonomyAPI.fetchClassesBySchool(classParam);
                if (this.cohort && this.cohort.aclSelected && this.cohort.aclSelected.length > 0) {
                    this.cohort.child[rowSelect].selectedCohort = [];
                    for await (const iteratorClass of classList) {
                        const aclIndex = this.cohort.aclSelected.findIndex((item: any) => {
                            return item.parentReferenceId === iteratorClass.parentId;
                        });

                        if (aclIndex !== -1) {
                            if (this.cohort.aclSelected[aclIndex].groups[0] === '*') {
                                iteratorClass.preSelect = true;
                                iteratorClass.checked = true;
                                const classIndex = this.cohort.child[rowSelect].selectedCohort.
                                    findIndex((item: any) => {
                                        return item.id === iteratorClass.id;
                                    });
                                if (classIndex === -1) {
                                    this.cohort.child[rowSelect].selectedCohort.push(iteratorClass);
                                }
                            } else if (this.cohort.aclSelected[aclIndex].groups.includes(iteratorClass.id)) {
                                iteratorClass.preSelect = true;
                                iteratorClass.checked = true;
                                const classIndex = this.cohort.child[rowSelect].selectedCohort.
                                    findIndex((item: any) => {
                                        return item.id === iteratorClass.id;
                                    });
                                if (classIndex === -1) {
                                    this.cohort.child[rowSelect].selectedCohort.push(iteratorClass);
                                }
                            }
                        }
                    }
                }
                for await (const iterator of classList) {
                    const classIndex = this.cohort.child[rowSelect].cohortList.findIndex((item: any) => {
                        return item.title === iterator.title &&
                            item.teacherUserName === iterator.teacherUserName
                            && iterator.parentId === rowSelect
                            && item.id === iterator.id;
                    });
                    if (classIndex === -1) {
                        this.cohort.child[rowSelect].cohortList.push(iterator);
                    }
                }
                // this.cohort.child[this.rowSelected].cohortList = classList;
                this.selectedParent = this.cohort.child[rowSelect];
                this.displayList = this.cohort.child[rowSelect].cohortList;
                this.selectedCohort = this.selectedParent.selectedCohort;
                setInterval(() => {
                    this.flagCheckonUpdate(this.selectedParent.selectedCohort);
                }, 1000);
                this.isloadingLocal = false;
            }
            this.selectedCohort = this.selectedParent && this.selectedParent.selectedCohort ?
                this.selectedParent.selectedCohort : [];
            this.flagCheckonUpdate(this.selectedParent.selectedCohort);
        } else {
            this.selectedCohort = this.selectedParent && this.selectedParent.selectedCohort ?
                this.selectedParent.selectedCohort : [];
            this.flagCheckonUpdate(this.selectedParent.selectedCohort);
            this.selectFirstAndDisplay();
        }
    }

    // -------------------------------------------------------------------------
    // Computed Properties

    get filteredItems() {
        return this.displayList.filter((item: any) => {
            if (item.type === 'class') {
                return item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 ||
                    item.teacherNameDisplay.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 ||
                    item.code.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
            } else {
                return item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
            }
        });
    }

    get getSelectedItemLength() {
        return this.cohort && this.cohort.child && this.cohort.child[this.rowSelected] &&
            this.cohort.child[this.rowSelected].selectedCohort
            ? this.cohort.child[this.rowSelected].selectedCohort.length : 0;
    }
    // -------------------------------------------------------------------
    // Hooks

    private created() {
        if (this.cohort.sequence === 1) {
            this.rowSelected = 0;
            this.displayList = this.cohort && this.cohort.child ? this.cohort.child[this.rowSelected].cohortList : [];
            this.selectedParent = this.cohort && this.cohort.child ? this.cohort.child[this.rowSelected] : {};
            const selectedIndex = this.displayList.findIndex((item: any) => {
                return item.preSelect || item.checked;
            });
            if (selectedIndex !== -1) {
                this.selectOneListItem(this.displayList[selectedIndex]);
                this.flagCheckonUpdate(this.selectedParent.selectedCohort);
                this.indeterminate = false;
                this.headerCheck = true;
            }
        }
    }

    // -------------------------------------------------------------------
    // Actions


    // -------------------------------------------------------------------
    // Methods


    private onSelectAll(event: any) {
        const selectedArray: any = [];
        const oldArray = this.selectedParent.selectedCohort || [];
        if (event) {
            for (const iterator of this.displayList) {
                iterator.checked = true;
                const selectIndex = this.cohort.child[this.rowSelected].selectedCohort.findIndex((item: any) => {
                    return item.id === iterator.id && item.parentId === iterator.parentId;
                });
                if (selectIndex === -1) {
                    this.cohort.child[this.rowSelected].selectedCohort.push(iterator);
                    this.$emit('selectAllChild', event, this.cohort, iterator);
                }
            }
            this.$emit('checkParentWithChild', this.rowSelected, this.cohort);
        } else {
            for (const iterator of this.displayList) {
                iterator.checked = false;
                this.$emit('unCheckAllChild', event, this.cohort, iterator);
            }
            this.selectedParent.selectedCohort = [];
        }
        const that = this;
        setTimeout(() => {
            if (event) {
                that.selectedRecentItem = that.displayList[0];
                that.selectOneListItem(that.selectedRecentItem);
            }
        }, 50);
    }

    private flagCheckonUpdate(data: any) {
        if (this.selectedCohort.length === 0) {
            this.indeterminate = false;
            this.headerCheck = false;
        } else if (this.selectedCohort.length > 0 && this.selectedCohort.length < this.displayList.length) {
            this.indeterminate = true;
        } else if (this.selectedCohort.length > 0 && this.selectedCohort.length === this.displayList.length) {
            this.indeterminate = false;
            this.headerCheck = true;
        }
    }


    private selectOneListItem(data: any) {
        const that = this;
        that.selectedRecentItem = data;
        that.$emit('selectOneListItem', data, that.cohort);
    }

    private onChangeOneListItem(data: any) {
        this.selectedRecentItem = data;
        if (data.checked || data.indeterminate) {
            data.indeterminate = false;
            const selectIndex = this.cohort.child[this.rowSelected].selectedCohort.findIndex((item: any) => {
                return item.id === data.id && item.parentId === data.parentId;
            });
            if (selectIndex === -1) {
                this.cohort.child[this.rowSelected].selectedCohort.push(data);
            }
            this.$emit('selectAllChild', true, this.cohort, data);
        } else {
            this.cohort.child[this.rowSelected].selectedCohort =
                this.cohort.child[this.rowSelected].selectedCohort.filter((item: any) => item.id !== data.id);
            this.$emit('unCheckAllChild', false, this.cohort, data);
        }
        this.selectedCohort = this.cohort.child[this.rowSelected].selectedCohort;
        this.flagCheckonUpdate(this.selectedCohort);
    }

    private rowSelectCheck() {
        if (!isEmpty(this.rowSelected) && this.displayList && this.displayList.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    private selectFirstAndDisplay() {
        const selectedIndex = this.displayList.findIndex((item: any) => {
            return item.preSelect || item.checked;
        });
        if (selectedIndex !== -1) {
            this.selectOneListItem(this.displayList[selectedIndex]);
            this.selectedRecentItem = this.displayList[selectedIndex];
            this.flagCheckonUpdate(this.selectedParent.selectedCohort);
        }
    }
}
